export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[680px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 mb-8">
            有任何问题、建议或内容合作意向，欢迎通过以下方式与我们取得联系
          </p>
          <div className="bg-background-100 border border-background-200 rounded-2xl p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <span className="w-12 h-12 flex items-center justify-center bg-primary-100 text-primary-500 rounded-xl mx-auto mb-3 text-xl">
                  <i className="ri-mail-line"></i>
                </span>
                <div className="text-xs text-foreground-500 mb-1">联系邮箱</div>
                <div className="text-sm font-medium text-foreground-800">contact@nunumovie.com</div>
              </div>
              <div className="text-center">
                <span className="w-12 h-12 flex items-center justify-center bg-accent-100 text-accent-500 rounded-xl mx-auto mb-3 text-xl">
                  <i className="ri-chat-3-line"></i>
                </span>
                <div className="text-xs text-foreground-500 mb-1">意见反馈</div>
                <div className="text-sm font-medium text-foreground-800">feedback@nunumovie.com</div>
              </div>
              <div className="text-center">
                <span className="w-12 h-12 flex items-center justify-center bg-secondary-100 text-secondary-500 rounded-xl mx-auto mb-3 text-xl">
                  <i className="ri-shake-hands-line"></i>
                </span>
                <div className="text-xs text-foreground-500 mb-1">内容合作</div>
                <div className="text-sm font-medium text-foreground-800">partner@nunumovie.com</div>
              </div>
            </div>
            <p className="text-xs text-foreground-400 leading-relaxed">
              我们会在收到邮件后的1-2个工作日内回复。如遇剧集播放问题，请提供具体的剧名和集数信息，方便我们快速排查处理。感谢你对努努影院的信任与支持！
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}